export default {"src":"/_next/static/media/background.4ad2f444.svg","height":254,"width":375,"blurWidth":0,"blurHeight":0};